import React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { captureUtms } from "@/utils/utm";
import App from "./App.jsx";
import "./index.css";

// Capture inbound utm_* params before React Router mounts or any redirect
// rewrites the URL, so we persist the true landing-page attribution.
captureUtms();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
